export default __webpack_public_path__ + "static/media/cow-graph.b1e4be26.svg";